import { render, staticRenderFns } from "./Penjualan.vue?vue&type=template&id=491d215c&scoped=true&"
import script from "./Penjualan.vue?vue&type=script&lang=js&"
export * from "./Penjualan.vue?vue&type=script&lang=js&"
import style0 from "./Penjualan.vue?vue&type=style&index=0&id=491d215c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491d215c",
  null
  
)

export default component.exports